<template>
  <div class="main" @click="itemClick()" @mouseout="itemMouseOut" @mouseover="itemMouseOver">
    <el-row style="padding-top: 15px;">
      <div class="leftopClass">
        <el-checkbox v-model="fileInfo.checked" style="padding-left: 10px;"
                     @change="checkboxChanged"
                     @click.native="checkboxClick($event)"></el-checkbox>
  <!--      <i v-if="fileInfo.fileType === 0" class="el-icon-folder" style="width: 20px;height: 20px;color: #3a8ee6;padding-left: 10px"></i>-->
  <!--      <i v-else class="el-icon-document" style="width: 20px;height: 20px;color: #3a8ee6;padding-left: 10px"></i>-->
  <!--      <div style="display: inline-block;padding-top: 10px;">-->
  <!--        -->
  <!--      </div>-->
        <img v-if="fileInfo.fileType === 0" src="../../assets/clouddisk/cloud_disk_type_icon_folder.png" class="file-type-icon"/>
        <template v-else>
          <img v-if="fileInfo.extName === 'jpg' || fileInfo.extName === 'jpeg'" src="../../assets/clouddisk/cloud_disk_type_icon_doc.png" class="file-type-icon"/>
          <img v-if="fileInfo.extName === 'jpg' || fileInfo.extName === 'jpeg'" src="../../assets/clouddisk/cloud_disk_type_icon_doc.png" class="file-type-icon"/>
          <img v-if="fileInfo.extName === 'png'" src="../../assets/clouddisk/cloud_disk_type_icon_doc.png" class="file-type-icon"/>
          <img v-else-if="fileInfo.extName === 'pdf'" src="../../assets/clouddisk/cloud_disk_type_icon_pdf.png" class="file-type-icon"/>
          <img v-else-if="fileInfo.extName === 'ppt' || fileInfo.extName === 'pptx'" src="../../assets/clouddisk/cloud_disk_type_icon_ppt.png" class="file-type-icon"/>
          <img v-else src="../../assets/clouddisk/cloud_disk_type_icon_ppt.png" class="file-type-icon"/>
        </template>

        <span v-if="fileInfo.isEdit === false || fileInfo.isEdit === undefined" style="height: 20px;margin-left: 10px">{{fileInfo.name}}</span>
        <el-input v-else class="fileNameInput" @click.native="inputClick($event)" size="small" @change="fileNameInputChangeFun"
                  placeholder="请输入文件名称"
                  v-model="fileInfo.name"></el-input>
      </div>
      <span style="float: right;padding-right: 20px;padding-left:20px;padding-top:4px;font-size: 13px;color: #999999;">{{fileInfo.updateTime}}</span>
      <el-button v-show="this.showTipComponents" type="danger" icon="el-icon-delete" size="mini" style="float: right;" @click.stop="delBtnClick"></el-button>
      <el-button v-show="this.showTipComponents" type="primary" icon="el-icon-edit" size="mini" style="float: right;margin-right: 20px" @click.stop="editBtnClick"></el-button>
      <span style="float: right;margin-right: 20px" v-show="fileInfo.extName === null || fileInfo.url === null || fileInfo.pageNum === 0">{{this.getTransformStatusLabel()}}</span>
    </el-row>

  </div>
</template>

<script>
export default {
  name: 'CloudDiskItemComponent',
  props: {
    fileInfo: {
      required: false
    }
  },
  data () {
    return {
      showTipComponents: false,
      isModify: false
    }
  },
  methods: {
    fileNameInputChangeFun () {
      this.fileInfo.isEdit = false
      if (this.isModify) {
        this.$emit('fielNameChanged')
      } else {
        this.$emit('fielNameChangedByAdd')
      }
    },
    itemClick () {
      this.$emit('itemClick')
    },
    delBtnClick () {
      this.$emit('delBtnClick')
    },
    checkboxChanged () {
      this.$emit('checkboxChanged')
    },
    editBtnClick () {
      this.isModify = true
      this.$set(this.fileInfo, 'isEdit', true)
    },
    inputClick (event) {
      event.stopPropagation()
    },
    checkboxClick (event) {
      event.stopPropagation()
    },
    itemMouseOver () {
      this.showTipComponents = true
    },
    itemMouseOut () {
      this.showTipComponents = false
    },
    getTransformStatusLabel () {
      let itemCreateTime = new Date(this.fileInfo.updateTime).getTime()
      if (itemCreateTime > new Date().getTime() - 60 * 60 * 1000) {
        return '文档转换中..'
      } else {
        return '文档转换失败'
      }
    }
  }
}
</script>

<style scoped>
  .main{
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #EFF2F7;
    cursor: pointer;
    text-align: left;
  }
  .main:hover{
    background-color: #F2F8FF;
  }
  .fileNameInput{
    width: 500px;
  }
  .leftopClass{
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    margin-left: 10px;
  }
  .file-type-icon{
    width: 20px;
    height: 20px;
    padding-left: 10px;
    padding-top: 3px
  }
</style>



// WEBPACK FOOTER //
// src/components/cloudDisk/CloudDiskItemComponent.vue